export const LINK_TYPE = {
  bookmark: 'bookmark',
  callToAction: 'call-to-action',
  button: 'button',
  youTube: 'youtube-video',
  book: 'book',
  subscribe: 'subscribe',
  scrollBlock: 'scroll-block',
  scrollTop: 'scroll-top',
  scrollToSection: 'scroll-to-section',
  download: 'download',
};
